import { useContext } from 'react';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import { UserContext } from '../context/UserContext';
import { useTwoStepVerification } from '../hooks/useTwoStepVerification';

// "אימות דו-שלבי" on the user's own profile (Microsoft accounts only). The choice
// is stored in Mashlom; Microsoft asks for and keeps the second factor. A super
// admin (in production), or a user their department's security policy covers,
// always has it and cannot switch it off. See docs/Authentication.md and
// docs/Security-Policies.md.
const TwoStepVerification = () => {
  const { user } = useContext(UserContext);
  const { change, isSaving, error } = useTwoStepVerification();
  const mfa = user?.mfa || {};
  const requiredAsSuperAdmin = mfa.reason === 'super_admin';
  const requiredByPolicy = mfa.reason === 'policy';
  const isLocked = requiredAsSuperAdmin || requiredByPolicy;
  const isOn = isLocked || Boolean(mfa.optedIn);

  return (
    <Box sx={{ p: 2, border: '1px solid #E4E7EC', borderRadius: '8px' }} dir="rtl">
      <Typography sx={{ fontWeight: 'bold', color: '#103C6E' }}>אימות דו-שלבי</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        {requiredAsSuperAdmin
          ? 'פעיל. אימות דו-שלבי נדרש למנהלי על.'
          : requiredByPolicy
            ? 'פעיל. אימות דו-שלבי נדרש לפי מדיניות האבטחה של המחלקה.'
            : isOn
              ? 'פעיל. בכל כניסה תתבקש/י להזין קוד אימות נוסף.'
              : 'הוספת שלב אימות בכניסה מגינה על החשבון גם אם הסיסמה נחשפה.'}
      </Typography>
      {!isLocked && (
        <FormControlLabel
          sx={{ mt: 1, mr: 0 }}
          control={(
            <Switch
              checked={isOn}
              disabled={isSaving}
              onChange={event => change(event.target.checked)}
            />
          )}
          label={isOn ? 'פעיל' : 'כבוי'}
        />
      )}
      {error && (
        <Typography color="error" role="alert" variant="body2" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default TwoStepVerification;
